// @flow
import React, { memo } from 'react';
import { isEmpty } from 'lodash';

type Props = {|
  items: [],
  displayAll: boolean,
  className: string,
  showAllCopy: number => string,
  toggleAll: () => void,
  render: any => any,
  doNotRender?: boolean
|};

// ItemList is in charge of the rendering of vehicles and also which vehicle is active
// and the hide/show functionality

const ItemList = memo(
  ({
    items,
    toggleAll,
    displayAll,
    className,
    showAllCopy,
    render,
    doNotRender = false
  }: Props) => {
    if (isEmpty(items) || doNotRender) {
      return null;
    }

    const itemsToRender = displayAll ? items : items.slice(0, 2);

    return (
      <>
        <ul className={`${className}`}>
          {itemsToRender.map(item => render(item))}
        </ul>
        {!displayAll &&
          items.length > 2 && (
            <button
              onClick={toggleAll}
              className={`${className}__showMore`}
              type="button"
            >
              {showAllCopy(items.length)}
            </button>
          )}
      </>
    );
  }
);

export default ItemList;
